import { useEffect, useRef, useState } from "react";
import DrawShape from "@/components/studio/DrawShape";
import SitePreview from "@/components/studio/SitePreview";

// Read-only, scaled preview of a saved design (canvas doc or website doc).
export default function DesignPreview({ doc, config = {}, height = 200, testid }) {
  const wrap = useRef(null);
  const [scale, setScale] = useState(0.3);
  const isSite = doc?.editorKind === "site" || Array.isArray(doc?.sections);
  const canvas = doc?.canvas || { w: 960, h: 540, bg: "#FFFFFF" };
  const inner = isSite ? 900 : canvas.w;

  useEffect(() => {
    const el = wrap.current;
    if (!el) return;
    const fit = () => setScale((el.clientWidth || inner) / inner);
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    return () => ro.disconnect();
  }, [inner]);

  return (
    <div ref={wrap} data-testid={testid} className="w-full overflow-hidden bg-white" style={{ height }}>
      <div style={{ width: inner, transform: `scale(${scale})`, transformOrigin: "top left", background: isSite ? undefined : canvas.bg }}>
        {isSite ? (
          <SitePreview doc={doc} config={config} />
        ) : (
          <div className="relative" style={{ width: canvas.w, height: canvas.h, background: canvas.bg }}>
            {(doc?.objects || []).map((o) => (
              <div key={o.id} className="absolute" style={{ left: o.x, top: o.y, width: o.w, height: o.h, transform: `rotate(${o.rot || 0}deg)`, opacity: o.opacity ?? 1 }}>
                <DrawShape o={o} gallery={config.gallery} videos={config.videos} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
